
import { useAuthFormState } from "./hooks/useAuthFormState";
import { useAuthRedirectUrl } from "./hooks/useAuthRedirectUrl";
import { ErrorDisplay } from "./forms/ErrorDisplay";
import { LoginForm } from "./forms/LoginForm";
import { PasswordResetForm } from "./forms/PasswordResetForm";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export const AuthForm = () => {
  const {
    error,
    setError,
    isPasswordReset,
    emailSent,
    setEmailSent,
    togglePasswordReset,
    setIsPasswordReset
  } = useAuthFormState();
  const redirectUrls = useAuthRedirectUrl();
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);
  const [initializingAuth, setInitializingAuth] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const checkRecoveryFlow = () => {
          const searchParams = new URLSearchParams(window.location.search);
          if (searchParams.get('type') === 'recovery') {
            return true;
          }

          const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
          if (hashParams.get('type') === 'recovery') {
            return true;
          }

          return location.search.includes('type=recovery') || location.hash.includes('type=recovery');
        };
        const isRecoveryFlow = checkRecoveryFlow();
        if (isRecoveryFlow) {
          console.log('Recovery flow detected in AuthForm, showing password reset form');
          setIsPasswordReset(true);

          localStorage.setItem('passwordResetRequired', 'true');
        }
      } catch (e) {
        console.error('Auth initialization error:', e);
      } finally {
        setInitializingAuth(false);
        setIsInitialized(true);
      }
    };

    const timer = setTimeout(() => {
      initializeAuth();
    }, 300);
    return () => clearTimeout(timer);
  }, [location, setIsPasswordReset]);

  if (!redirectUrls || !isInitialized || initializingAuth) {
    return <div className="flex flex-col items-center justify-center p-4 space-y-2">
        <Loader2 className="h-6 w-6 animate-spin text-green-400" />
        <p className="text-sm text-zinc-400">Initializing authentication...</p>
      </div>;
  }

  if (isPasswordReset) {
    return <div className="w-full">
        <div className="text-center mb-2">
          <h2 className="text-xl font-bold text-white">Reset Your Password</h2>
          <p className="text-xs mt-0.5 text-zinc-400">Enter your email address and we'll send you a reset link</p>
        </div>
        
        <ErrorDisplay error={error} />
        
        <PasswordResetForm 
          onToggleForm={togglePasswordReset} 
          emailSent={emailSent} 
          setEmailSent={setEmailSent} 
          error={error} 
          setError={setError}
          showPasswordResetNotification={location.search.includes('type=recovery') || location.hash.includes('type=recovery')} 
        />
      </div>;
  }

  return <div className="w-full">
      <ErrorDisplay error={error} />
      
      <LoginForm 
        redirectUrl={redirectUrls.successUrl} 
        onToggleForm={togglePasswordReset} 
        showPasswordResetNotification={location.search.includes('type=recovery') || location.hash.includes('type=recovery')} 
      />
    </div>;
};

export default AuthForm;
